import {DROP_DOWN} from '~/assets/js/constants'
import {filterBy} from '@progress/kendo-data-query'
import isEqual from 'lodash/isEqual'
import useInputValidation from '~/composables/useInputValidation'

export const useDropdown = (options = {}) => {
  const {
    getDataItems,
    getAttrs,
    rules = [],
    skipClientFilter = false
  } = options

  const {
    errorMessage,
    fallbackValue,
    validate,
    getName
  } = useInputValidation({rules, getAttrs})

  const items = ref([])
  const cssClasses = ref('')

  const initializeItems = () => {
    const dataItems = getDataItems?.() ?? []
    items.value = dataItems.slice()
  }

  const watchDataItems = () => {
    watch(
      () => getDataItems?.() ?? [],
      (newVal) => {
        onDataItemsChanged(newVal)
      },
      {deep: true}
    )
  }

  const onDataItemsChanged = (newVal) => {
    if (!isEqual(newVal, items.value)) {
      items.value = newVal.slice()
    }
  }

  const filterChange = (event) => {
    if (skipClientFilter) {
      return
    }
    items.value = filterData(event.filter)
  }

  const filterData = (filter) => {
    const data = getDataItems?.()?.slice() ?? []
    return filterBy(data, filter)
  }

  const onOpen = () => {
    if (!cssClasses.value.includes(DROP_DOWN.OpenIconClass)) {
      cssClasses.value += ' ' + DROP_DOWN.OpenIconClass
    }
  }

  const onClose = () => {
    if (cssClasses.value.includes(DROP_DOWN.OpenIconClass)) {
      cssClasses.value = cssClasses.value.replace(DROP_DOWN.OpenIconClass, '').trim()
    }
  }

  initializeItems()
  watchDataItems()

  return {
    items,
    cssClasses,
    errorMessage,
    fallbackValue,
    onDataItemsChanged,
    filterChange,
    filterData,
    onOpen,
    onClose,
    validate,
    getName
  }
}

export const DEFAULT_DROPDOWN_ICON_CLASS = 'k-i-arrow-chevron-down'

export default useDropdown
